exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, ".error-content[data-v-630f9c82]{padding:20px 0;display:flex;flex-direction:column;gap:5px;align-items:center}", ""]);

// exports
